import React, { useId, useState } from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import SecurityIdentityFieldSelector, {
    SecurityIdentityColumnHeader,
} from '../commonComponents/SecurityIdentityFieldSelector';
import { securityIdentityPresentation } from '../../utils/securityIdentityPresentation';

// Review rows may precede resolution. Keep their submitted identifier visible
// when there is no company label yet; display fields never assign identity.
export default function useWatchlistReviewIdentity() {
    const [field, setField] = useState('company_name');
    const [anchorEl, setAnchorEl] = useState(null);
    const selectorId = useId();
    return {
        header: <SecurityIdentityColumnHeader value={field} selectorId={selectorId}
            anchorEl={anchorEl} onOpen={setAnchorEl} />,
        selector: <SecurityIdentityFieldSelector value={field} selectorId={selectorId}
            anchorEl={anchorEl} onChange={setField} onClose={() => setAnchorEl(null)}
            ariaLabel="Review security identity field"
            helperText="Choose company name, ticker, or submitted identifier." />,
        renderIdentity: (row) => {
            const type = String(row?.inbound_id_type || row?.uploaded_identifier_type
                || row?.security_id_type || row?.id_type || row?.identifier_type || '').trim();
            const internal = type.toLowerCase() === 'cognive_id';
            const value = internal ? '' : String(
                row?.inbound_id_value || row?.uploaded_identifier_value
                || row?.security_id_value || row?.id_value || row?.identifier_value || '',
            ).trim();
            const presentation = securityIdentityPresentation(row, field);
            const showIdentifier = field === 'submitted_identifier'
                || (field === 'company_name' && presentation.value === '—');
            if (showIdentifier) {
                return <Box display="flex" alignItems="center" gap={0.75} flexWrap="wrap">
                    {value && type && <Chip size="small" label={type.toUpperCase()} variant="outlined"
                        sx={{ height: 20, fontSize: '0.68rem', fontWeight: 700 }} />}
                    <Typography variant="body2" component="span">
                        {value || (internal ? '—' : row?.uploaded_ticker || row?.ticker) || '—'}
                    </Typography>
                </Box>;
            }
            return <Tooltip title={presentation.tooltip} arrow>
                <Typography variant="body2" component="span">{presentation.value}</Typography>
            </Tooltip>;
        },
    };
}
